import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ApiApi, UserRole } from '../backendsdk';
import useApi from './api';

const getCustomer = async (api: ApiApi) => {
    const res = await api.apiV0CustomerGet();
    let image = '';
    if (res.data.logo_url) {
        image = await axios
            .get(res.data.logo_url, {
                responseType: 'blob',
            })
            .then((r) => {
                return new Promise<string>((resolve, reject) => {
                    const reader = new window.FileReader();
                    reader.readAsDataURL(r.data);
                    reader.onload = function () {
                        const imageResult = reader.result;
                        if (typeof imageResult === 'string') {
                            resolve(imageResult);
                        }
                    };
                    reader.onerror = reject;
                });
            });
    }
    return { ...res.data, logo_url: image };
};

const useCustomer = (includeAllUsers = false) => {
    const { api } = useApi();
    const {
        data: customer,
        isLoading,
        isFetching,
        isError,
    } = useQuery({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: ['customer'],
        queryFn: () => getCustomer(api),
    });
    let users = customer?.users || [];
    if (!includeAllUsers) {
        users = users.filter((user) => user.role !== UserRole.GuestTechnician);
    }
    return { customer, customerUsers: users, isLoading, isFetching, isError };
};

export default useCustomer;
